export * from './header/header.component';
export * from './footer/footer.component';
export * from './search-input/search-input.component';
//export * from './tiny-mce/tiny-mce.component';
export * from './theme-settings/theme-settings.component';
//export * from './theme-switcher/theme-switcher.component';
//export * from './switcher/switcher.component';
//export * from './layout-direction-switcher/layout-direction-switcher.component'
